import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaLoaderService {
  private loaded = false;

  constructor() {}

  public load(siteKey: string): Promise<void> {
    if (this.loaded) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.onload = () => {
        this.loaded = true;
        resolve();
      };
      script.onerror = () => reject('Could not load reCAPTCHA script');
      document.head.appendChild(script);
    });
  }
}
